import { render } from "./massTool.vue?vue&type=template&id=f746b64e&scoped=true&ts=true"
import script from "./massTool.vue?vue&type=script&lang=ts"
export * from "./massTool.vue?vue&type=script&lang=ts"

import "./massTool.vue?vue&type=style&index=0&id=f746b64e&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f746b64e"]])

export default __exports__